export class LaborAmendMembershipWriteBlockedError extends Error {
  constructor() {
    super("Labor stage membership writes are blocked until Sign & Lock.");
    this.name = "LaborAmendMembershipWriteBlockedError";
  }
}

export interface LaborAmendMembershipWriteGuard {
  isDeferredAmendMode: () => boolean;
  canWriteMembership: () => boolean;
}

let laborAmendMembershipWriteGuard: LaborAmendMembershipWriteGuard | undefined;

/**
 * Installed by LaborAmendFlowsheetPersistProvider while flowsheet persists are deferred.
 */
export function setLaborAmendMembershipWriteGuard(
  guard: LaborAmendMembershipWriteGuard | undefined,
): void {
  laborAmendMembershipWriteGuard = guard;
}

/**
 * Throws when a membership write is attempted outside an active amend flush.
 */
export function assertLaborAmendMembershipWriteAllowed(): void {
  const guard = laborAmendMembershipWriteGuard;
  if (!guard?.isDeferredAmendMode()) {
    return;
  }
  if (!guard.canWriteMembership()) {
    throw new LaborAmendMembershipWriteBlockedError();
  }
}
